// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as WorkSpaceContext from "../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as CustomerApiHandler from "../state-machine/CustomerApiHandler.bs.js";
import * as CustomerOrderTableCmp from "./CustomerOrderTableCmp.bs.js";
import * as CustomerOrderStateMachine from "../state-machine/CustomerOrderStateMachine.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";

function CustomerOrderPage(Props) {
  var uuid = Props.uuid;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer(CustomerOrderStateMachine.StateMachine.machine, /* Init */0);
  var dispatch = match$1[1];
  var state = match$1[0];
  WorkSpaceContext.useWorkSpace(undefined);
  var match$2 = React.useState(function () {
        return false;
      });
  var setLoader = match$2[1];
  var fetchCustomerOrder = function (uuid, page_size, last_date_timestamp) {
    return function (param) {
      return CustomerApiHandler.FetchCustomerOrder.execute((function (data) {
                    return Curry._1(dispatch, {
                                TAG: /* SetCustomerOrder */0,
                                _0: data
                              });
                  }), (function (error) {
                    return Curry._1(dispatch, {
                                TAG: /* SetCustomerOrderFailed */1,
                                _0: error
                              });
                  }), uuid, page_size, last_date_timestamp, param);
    };
  };
  React.useEffect((function () {
          fetchCustomerOrder(uuid, 20, undefined)(country);
          
        }), []);
  if (typeof state === "number") {
    return React.createElement(LoadingViewComponent$Catalyst.make, {});
  } else if (state.TAG === /* CustomerOrder */0) {
    return React.createElement("div", {
                className: "order_history_page"
              }, match$2[0] ? React.createElement("div", {
                      className: "loader-wrapper"
                    }, React.createElement(LoadingViewComponent$Catalyst.make, {})) : null, React.createElement(CustomerOrderTableCmp.make, {
                    data: state._0,
                    updateTable: (function (list_end_time) {
                        if (Caml_obj.caml_equal(list_end_time, "0")) {
                          return ;
                        } else {
                          Curry._1(setLoader, (function (param) {
                                  return true;
                                }));
                          return CustomerApiHandler.FetchCustomerOrder.execute((function (data) {
                                        Curry._1(setLoader, (function (param) {
                                                return false;
                                              }));
                                        return Curry._1(dispatch, {
                                                    TAG: /* UpdateCustomerOrder */2,
                                                    _0: data
                                                  });
                                      }), (function (error) {
                                        Curry._1(setLoader, (function (param) {
                                                return false;
                                              }));
                                        return Curry._1(dispatch, {
                                                    TAG: /* UpdateCustomerOrderFailed */3,
                                                    _0: error
                                                  });
                                      }), uuid, 100, list_end_time, country);
                        }
                      })
                  }));
  } else {
    return null;
  }
}

var make = CustomerOrderPage;

export {
  make ,
  
}
/* react Not a pure module */
